import React, { useState } from "react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function login(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("https://enteai-web-lj55.vercel.app/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      if (data.token) {
        localStorage.setItem("adminToken", data.token);
        window.location.href = "/admin/dashboard";
      } else {
        setError("Invalid login credentials");
      }
    } catch {
      setError("Server not responding");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Admin Login</h2>
        <p style={styles.subtitle}>Access Admin Dashboard</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={login} style={styles.form}>
          <input
            type="email"
            placeholder="Admin Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={styles.input}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={styles.input}
            required
          />

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

// ✅ Styles
const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #020617, #020617)"
  },
  card: {
    width: "100%",
    maxWidth: 400,
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
    padding: 32,
    textAlign: "center"
  },
  title: {
    fontSize: 24,
    marginBottom: 6,
    color: "#0f172a"
  },
  subtitle: {
    fontSize: 14,
    marginBottom: 20,
    color: "#64748b"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 14 ,
    color: "#ffffff"
  },
  input: {
    padding: "12px 14px",
    borderRadius: 10,
    border: "1px solid #e2e8f0",
    fontSize: 14,
    outline: "none"
  },
  button: {
    marginTop: 10,
    padding: "12px",
    borderRadius: 10,
    background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
    color: "#ffffff",
    border: "none",
    fontWeight: "bold",
    fontSize: 15,
    cursor: "pointer"
  },
  error: {
    background: "#fee2e2",
    color: "#991b1b",
    padding: "10px 12px",
    borderRadius: 10,
    marginBottom: 14,
    fontSize: 14
  }
};
